import { propertiesStore } from "properties/_stores/propertiesStore";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import React from "react";
import closeModal from "../../../assets/images/icons/closeModalWhite.svg";
import { useLoadingFromPromise } from "_common/loaders/useLoadingFromPromise";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";

export const PropertyCompareCard = ({ itemId }: { itemId: string }) => {
    const { toggleCompare } = useCompare();
    const promise = propertiesStore.findOneAsync("_id", itemId);
    const { loading } = useLoadingFromPromise(promise);
    if (!loading) return null;

    return (
        <LoadableFromLoading
            loading={loading}
            renderer={(_status, error, value) => {
                if (error || !value) return null;
                const property = value;
                return (
                    <div className="relative h-[50px] w-[50px] md:h-[80px] md:w-[80px]">
                        <LazyLoadImage
                            src={property?.photos?.[0]?.url}
                            alt={"property image"}
                            title={`${property?.localized.title} photo 2`}
                            className="h-full w-full object-cover rounded"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = `https://placehold.co/300x300?text=Zisla.com`;
                            }}
                        />
                        <div
                            className="absolute top-0 left-0 transform -translate-x-2 -translate-y-2 w-5 h-5 bg-[#f3615b] rounded-full flex items-center justify-center text-white text-xs cursor-pointer"
                            onClick={() =>
                                toggleCompare({
                                    itemId: itemId,
                                    resource: COMMON_RESOURCE.PROPERTIES,
                                    type: property.type,
                                })
                            }
                        >
                            <img src={closeModal} className={"h-2 w-2"} />
                        </div>
                    </div>
                );
            }}
        />
    );
};
